module.exports = __webpack_public_path__ + "img/leadership-1980-zhang-youyu.44a2395f.jpg";